// import { notification } from 'antd';
// import API from '../api/jongjonan';
import { checkToken } from './auth';
import { fetchInstansi } from './instansi';

/**
 * Constants
 */

export const INITIALIZING = "app/INITIALIZING";
export const INITIALIZED = "app/INITIALIZED";

/**
 * Actions
 */
export function init() {
    return async dispatch =>
        new Promise(async (resolve, reject) => {
            try {
                const token = localStorage.getItem('token');
                dispatch({ type: INITIALIZING, token });

                // Check for token expiration
                if (token) {
                    await Promise.all([dispatch(checkToken()), dispatch(fetchInstansi())]);
                }

                dispatch({ type: INITIALIZED, token });
                resolve(token);
            } catch (error) {
                reject(error);
                dispatch({
                    type: INITIALIZED,
                    error: error.message
                });
            }
        })
}


/**
 * Reducer
 */
const initialState = {
    bidang_keahlian: [
        'Berhubungan dengan Desain Grafis',
        'Tidak berhubungan dengan Desain Grafis',
    ],
    'kapabilitas': [
        'Art Direction',
        'Branding',
        'Editorial Design',
        'Environmental Graphic Design',
        'Illustration',
        'Interaction Design',
        'Motion Graphics',
        'Photography',
        'Print Design',
        'UI/UX',
        'Typography',
        'Web Design',
    ],
};

export default function app(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/app.js